import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {TransactionsComponent} from '../transactions/transactions.component';
import {OrdersComponent} from './orders.component';

const routes: Routes = [
  {
    path: 'orders',
    component: OrdersComponent,
    data: {animation: 'orders'}
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrdersRoutingModule { }
